import axios from 'axios/index'

export default function addEditCustomerGroup(customerGroup, config) {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };

  const url = config.postCustomerGroups;
  return dispatch => dispatch({
    type: 'ADD_EDIT_CUSTOMER_GROUP_SAVE',
    payload: axios({ method: 'post', url, headers, data: { customerGroup } })
  })
}



// WEBPACK FOOTER //
// ./src/actions/addEditCustomerGroup.js